import * as React from "react";
const SvgCopy = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M3.843 14.447A1.671 1.671 0 0 1 3 13V4.667C3 3.75 3.75 3 4.667 3H13c.625 0 .965.32 1.25.833M6.333 8.556a2.222 2.222 0 0 1 2.223-2.223h7.222A2.222 2.222 0 0 1 18 8.556v7.222A2.222 2.222 0 0 1 15.777 18H8.556a2.222 2.222 0 0 1-2.223-2.223V8.556Z"
    }
  )
);
export default SvgCopy;
